<template>
  <v-dialog persistent width="450" v-model="dialogOpen">
    <v-card>
      <v-card-title>Lead Management</v-card-title>

      <v-card-text>
        <v-row>
          <v-col>
            <v-autocomplete v-model="sales_person" item-text="text" item-value="value" label="Sales Person" :items="getTeamByRoles(['voip-sales','sa-sales','sales-workgroup'])" :error-messages="salesPersonErrors" @change="$v.sales_person.$touch()" @blur="$v.sales_person.$touch()" :disabled="!hasUserGotRoles(grantAccess.salesPersonField)" :loading="getCrmUsersLoading" outlined dense required :no-data-text="salePersonNoDataText" hide-details="auto"></v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="save" :disabled="formLoading" :loading="formLoading">Save</v-btn>
        <v-btn color="primary" outlined small @click="close">cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { validationMixin } from "vuelidate";
  import { required } from "vuelidate/lib/validators";
  import { mapGetters,mapActions,mapState } from "vuex";

  export default {
    props: {
      dialogOpen: {
        type: Boolean,
        default: false
      }
    },

    mixins: [ validationMixin ],

    validations: {
      sales_person: { required },
    },

    data() {
      return {
        grantAccess: {
          salesPersonField: ['sales-lead', 'team-leader']
        },
        sales_person: "",
        formLoading: false,
      }
    },

    computed: {
      ...mapState('leads',['currentLead']),
      ...mapGetters('globals', ['getCurrentUserRoles','hasUserGotRoles']),
      ...mapGetters('crmUsers', ['getCrmUsers', 'getCrmUsersLoading', 'getCrmUsersError', 'getCrmUsersErrorMsg', 'getTeamByRoles']),

      salesPersonErrors() {
        const errors = [];
        if (!this.$v.sales_person.$dirty) return errors;
        !this.$v.sales_person.required && errors.push("Sales Person is required");
        return errors;
      },

      salePersonNoDataText() {
        if(this.getCrmUsersLoading){
          return "Loading...";
        }
        if(this.getCrmUsersError) {
          return "Error Loading Users";
        }
      }
    },

    watch: {
      dialogOpen(val) {
        if(val){
          this.sales_person = this.currentLead.sales_person;
          this.loadCRMUsers();
        }
      }
    },

    methods: {
      ...mapActions('leads',['updateLeadSalesPerson']),
      ...mapActions('crmUsers',['fetchCRMUsers']),

      loadCRMUsers() {
        if(this.sales_person === "unassigned") {
          this.sales_person = "";
        }
        this.fetchCRMUsers();
      },

      close() {
        this.sales_person = this.currentLead.sales_person;
        this.$v.$reset();
        this.$emit('close-dialog');
      },

      async save() {
        this.$v.$touch();
        if(!this.$v.$error){
          this.formLoading = true;
          let data = {
            id: this.currentLead.id,
            data: { sales_person: this.sales_person }
          };
          try{
            await this.updateLeadSalesPerson(data);
            this.formLoading = false;
            this.close();
          }catch(error){
            this.formLoading = false;
          }
        }
      },
    },
  }
</script>

<style lang="scss" scoped></style>
